import { ClearOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, theme } from 'antd';
import { useEffect, useState } from 'react';
import dayjs from 'libs/dayjs';
import ClienteSelect from 'components/selects/ClienteSelect';
import DateRangeFilter from 'components/filters/DateRangeFilter';

const { useToken } = theme;

// Deriva el value [dayjs, dayjs] | null que consume el RangePicker a partir
// de los strings YYYY-MM-DD persistidos en filters.
const toRangeValue = (from, to) =>
  from || to ? [from ? dayjs(from) : null, to ? dayjs(to) : null] : null;

/**
 * Toolbar de Folders. Expone busqueda (debounced) + select de cliente +
 * boton de limpiar. `supportsSearch` es false para los tipos que aun no
 * filtran server-side por texto (mantenciones, mantencionesDep).
 */
function FoldersToolbar({ filters, onChange, supportsSearch }) {
  const { token } = useToken();
  const [searchInput, setSearchInput] = useState(filters.search ?? '');

  useEffect(() => {
    const t = setTimeout(() => {
      if (searchInput !== (filters.search ?? '')) {
        onChange({ ...filters, search: searchInput });
      }
    }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput]);

  const hasFilters =
    !!filters.search || !!filters.idClient || !!filters.dateFrom || !!filters.dateTo;

  const clearAll = () => {
    setSearchInput('');
    onChange({ ...filters, search: '', idClient: null, dateFrom: null, dateTo: null });
  };

  return (
    <Space
      wrap
      size="middle"
      style={{
        padding: token.paddingSM,
        background: token.colorBgContainer,
        border: `1px solid ${token.colorBorder}`,
        borderRadius: token.borderRadiusLG,
      }}
    >
      {supportsSearch && (
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder="Buscar por descripción…"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          style={{ width: 280 }}
        />
      )}
      <div style={{ minWidth: 240 }}>
        <ClienteSelect
          onChange={(value) => onChange({ ...filters, idClient: value === true ? null : value })}
        />
      </div>
      <DateRangeFilter
        value={toRangeValue(filters.dateFrom, filters.dateTo)}
        onChange={(from, to) => onChange({ ...filters, dateFrom: from, dateTo: to })}
      />
      {hasFilters && (
        <Button icon={<ClearOutlined />} onClick={clearAll}>
          Limpiar
        </Button>
      )}
    </Space>
  );
}

export default FoldersToolbar;
